import React, { useState } from "react";
import "./Refunds.css";
import RefundRequest from "./RefundRequest";
import RefundProcessing from "./RefundProcessing";
import Refunded from "./Refunded";
import RefundRequestDenied from "./RefundRequestDenied";
import LoaderSmall from "../../Shared/LoderSmall/LoaderSmall";
import Loading from "../../Shared/Loading/Loading";
import LoaderBigTwo from "../../Shared/LoaderBigTwo/LoaderBigTwo";

const Refunds = () => {
   
  const [activeTab, setActiveTab] = useState(1); // Set the default active tab to 2 (Tab 2)

  // Function to handle tab click
  const handleTabClick = (tabIndex) => {
      setActiveTab(tabIndex);
  };

  return (
    <div>
      <div className='w-full h-32 flex justify-center items-center bg-gray-50'>
        <h2 className='headingTxt'>Refunds</h2>
      </div>
      <div className='px-5 mt-5'>
                <div className='grid grid-cols-4 gap-5 py-2 w-[600px]'>
                    <button onClick={() => handleTabClick(1)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Refund Request</button>
                    <button onClick={() => handleTabClick(2)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Processing</button>
                    <button onClick={() => handleTabClick(3)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Refunded</button>
                    <button onClick={() => handleTabClick(4)} className='w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl'>Request Denied</button>

           </div>
                {/* Content for Tab 1 */}
                {activeTab === 1 && (
                    <div className="tab-content w-full">
                        <RefundRequest></RefundRequest>
                    </div>
                )}

                {/* Content for Tab 2 */}
                {activeTab === 2 && (
                    <div className='tab-content w-full'>
                       <RefundProcessing></RefundProcessing>
                    </div>
                )}
                {/* Content for Tab 3 */}
                {activeTab === 3 && (
                    <div className='tab-content w-full'>
                       <Refunded></Refunded>
                    </div>
                )}
                {/* Content for Tab 4 */}
                {activeTab === 4 && (
                    <div className='tab-content w-full'>
                       <RefundRequestDenied></RefundRequestDenied>
                    </div>
                )}

            </div>
    </div>
  );
};

export default Refunds;
